import { novaClient } from "@/lib/trpc";

export function useUpdateSetUserNote() {
  const novaClientUtils = novaClient.useUtils();

  return novaClient.internal.user.note.update.useMutation({
    onSuccess: (updatedNote) => {
      novaClientUtils.internal.user.note.list.setData(
        { userId: updatedNote.userId },
        (cachedNotes) =>
          cachedNotes?.map((cachedNote) =>
            cachedNote.id === updatedNote.id ? updatedNote : cachedNote,
          ),
      );
    },
  });
}
